<template>
  <el-pagination
    :total="total"
    :current-page="page + 1"
    :page-size="size"
    :page-sizes="[10, 20, 50]"
    style="margin-top: 8px;"
    layout="total, prev, pager, next, sizes"
    @size-change="$emit('size-change', $event)"
    @current-change="$emit('page-change', $event)"
  />
</template>

<script>
export default {
  name: 'SchoolListPagination',
  props: {
    total: { type: Number, default: 0 },
    page: { type: Number, default: 0 },
    size: { type: Number, default: 20 }
  }
}
</script>
